<div class="container margin-on-scrol" [id]="slice.sectionId">
  <div class="mx-4 lg:mx-0 my-8 lg:my-16">
    <div class="flex flex-col items-center" [class]="slice.image_position_desktop">
      @if (slice.images) {
        <img
          class="h-full object-contain max-h-full order-1"
          [srcset]="slice.images.htmlSrcset"
          sizes="(max-width: 768px) 100vw, 50vw"
          [alt]="slice.images.alt"
          [src]="slice.images.smallest.url"
          [attr.loading]="lazyLoadImage ? 'lazy' : 'eager'"
          width="100%"
          height="160"
        />
      }
      <div class="order-2">
        @if (slice.title.length !== 9) {
          <div data-source="prismic" class="mx-4 text-center text-dark my-3" [innerHtml]="slice.title"></div>
        }

        @if (slice.text.length >= 9) {
          <div data-source="prismic" class="mx-4 text-center text-dark my-3">
            <ngx-dynamic-hooks
              data-source="prismic"
              [content]="slice.text"
              [options]="{ sanitize: false }"
              class="grow flex flex-col"
            >
            </ngx-dynamic-hooks>
          </div>
        }
        @if (slice.button_text && slice.button_link) {
          <div class="flex justify-center">
            <lib-link class="w-60 self-center button mb-5" [link]="slice.button_link">
              <div class="text-center text-white">{{ slice.button_text }}</div>
            </lib-link>
          </div>
        }
      </div>
    </div>
  </div>
</div>
